"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CHANNEL_ADAPTER_METHODS", {
  enumerable: true,
  get: function () {
    return _channelAdapter.CHANNEL_ADAPTER_METHODS;
  }
});
Object.defineProperty(exports, "CONVERSATION_KIND", {
  enumerable: true,
  get: function () {
    return _constants.CONVERSATION_KIND;
  }
});
Object.defineProperty(exports, "ConversationProvider", {
  enumerable: true,
  get: function () {
    return _ConversationProvider.ConversationProvider;
  }
});
Object.defineProperty(exports, "DEFAULT_LANGUAGE_LIST", {
  enumerable: true,
  get: function () {
    return _constants.DEFAULT_LANGUAGE_LIST;
  }
});
Object.defineProperty(exports, "MAX_UPLOAD_FILE_SIZE_BYTES", {
  enumerable: true,
  get: function () {
    return _constants.MAX_UPLOAD_FILE_SIZE_BYTES;
  }
});
Object.defineProperty(exports, "MESSAGE_STATUS", {
  enumerable: true,
  get: function () {
    return _constants.MESSAGE_STATUS;
  }
});
Object.defineProperty(exports, "QUICK_REACTIONS", {
  enumerable: true,
  get: function () {
    return _constants.QUICK_REACTIONS;
  }
});
Object.defineProperty(exports, "SOCKET_EVENTS", {
  enumerable: true,
  get: function () {
    return _constants.SOCKET_EVENTS;
  }
});
Object.defineProperty(exports, "VirtualizedMessageList", {
  enumerable: true,
  get: function () {
    return _useVirtualizedList.VirtualizedMessageList;
  }
});
Object.defineProperty(exports, "assertChannelAdapter", {
  enumerable: true,
  get: function () {
    return _channelAdapter.assertChannelAdapter;
  }
});
Object.defineProperty(exports, "conversationReducer", {
  enumerable: true,
  get: function () {
    return _conversationReducer.conversationReducer;
  }
});
Object.defineProperty(exports, "createChatClient", {
  enumerable: true,
  get: function () {
    return _createChatClient.createChatClient;
  }
});
Object.defineProperty(exports, "createOptimisticMessage", {
  enumerable: true,
  get: function () {
    return _normalize.createOptimisticMessage;
  }
});
Object.defineProperty(exports, "createSocketIoAdapter", {
  enumerable: true,
  get: function () {
    return _socketIoAdapter.createSocketIoAdapter;
  }
});
Object.defineProperty(exports, "getFileKind", {
  enumerable: true,
  get: function () {
    return _messageHelpers.getFileKind;
  }
});
Object.defineProperty(exports, "handleEnterKey", {
  enumerable: true,
  get: function () {
    return _textHelpers.handleEnterKey;
  }
});
Object.defineProperty(exports, "initialConversationState", {
  enumerable: true,
  get: function () {
    return _conversationReducer.initialConversationState;
  }
});
Object.defineProperty(exports, "isPreviewableInline", {
  enumerable: true,
  get: function () {
    return _messageHelpers.isPreviewableInline;
  }
});
Object.defineProperty(exports, "markMessageFailed", {
  enumerable: true,
  get: function () {
    return _messageHelpers.markMessageFailed;
  }
});
Object.defineProperty(exports, "normalizeConversation", {
  enumerable: true,
  get: function () {
    return _normalize.normalizeConversation;
  }
});
Object.defineProperty(exports, "normalizeMessage", {
  enumerable: true,
  get: function () {
    return _normalize.normalizeMessage;
  }
});
Object.defineProperty(exports, "reconcileOptimisticMessage", {
  enumerable: true,
  get: function () {
    return _messageHelpers.reconcileOptimisticMessage;
  }
});
Object.defineProperty(exports, "removeMessageById", {
  enumerable: true,
  get: function () {
    return _messageHelpers.removeMessageById;
  }
});
Object.defineProperty(exports, "replaceMessageById", {
  enumerable: true,
  get: function () {
    return _messageHelpers.replaceMessageById;
  }
});
Object.defineProperty(exports, "useAutoResizeTextarea", {
  enumerable: true,
  get: function () {
    return _useAutoResizeTextarea.useAutoResizeTextarea;
  }
});
Object.defineProperty(exports, "useConversation", {
  enumerable: true,
  get: function () {
    return _useConversation.useConversation;
  }
});
Object.defineProperty(exports, "useConversationContext", {
  enumerable: true,
  get: function () {
    return _ConversationProvider.useConversationContext;
  }
});
Object.defineProperty(exports, "useMessageComposer", {
  enumerable: true,
  get: function () {
    return _useMessageComposer.useMessageComposer;
  }
});
Object.defineProperty(exports, "useRowHeights", {
  enumerable: true,
  get: function () {
    return _useVirtualizedList.useRowHeights;
  }
});
Object.defineProperty(exports, "useSpeechToText", {
  enumerable: true,
  get: function () {
    return _useSpeechToText.useSpeechToText;
  }
});
Object.defineProperty(exports, "useTextToSpeech", {
  enumerable: true,
  get: function () {
    return _useTextToSpeech.useTextToSpeech;
  }
});
Object.defineProperty(exports, "useTranslationFlag", {
  enumerable: true,
  get: function () {
    return _useTranslationFlag.useTranslationFlag;
  }
});
Object.defineProperty(exports, "useTypingIndicator", {
  enumerable: true,
  get: function () {
    return _useTypingIndicator.useTypingIndicator;
  }
});
var _socketIoAdapter = require("./core/adapters/socketIoAdapter");
var _channelAdapter = require("./core/channelAdapter");
var _normalize = require("./core/normalize");
var _ConversationProvider = require("./state/ConversationProvider");
var _useConversation = require("./state/useConversation");
var _conversationReducer = require("./state/conversationReducer");
var _createChatClient = require("./networking/createChatClient");
var _useSpeechToText = require("./hooks/useSpeechToText");
var _useTextToSpeech = require("./hooks/useTextToSpeech");
var _useTranslationFlag = require("./hooks/useTranslationFlag");
var _useTypingIndicator = require("./hooks/useTypingIndicator");
var _useMessageComposer = require("./hooks/useMessageComposer");
var _useAutoResizeTextarea = require("./hooks/useAutoResizeTextarea");
var _useVirtualizedList = require("./hooks/useVirtualizedList");
var _messageHelpers = require("./utils/messageHelpers");
var _textHelpers = require("./utils/textHelpers");
var _constants = require("./utils/constants");